import { createSlice } from "@reduxjs/toolkit";
const skuSlice = createSlice({
  name: "sku",
  initialState: "",
  reducers: {
    saveSku: (state, action) => action.payload,
  },
});

export default skuSlice;